import React, { FC } from 'react'
import Input from '@vtex/styleguide/lib/Input'
import Button from '@vtex/styleguide/lib/Button'

interface InputButtonProps {
  buttonProps: {
    disabled: boolean
    isLoading: boolean
    text: string
    testId?: string
    size: string
    onClick?: (event: InputValueEvent) => void
    type?: string
    hasCustomButton?: boolean
  }
  errorMessage?: string
  inputMode?: string
  id?: string
  testId?: string
  label?: string
  disabled: boolean
  onChange: (event: InputValueEvent) => void
  onBlur: (event: InputValueEvent) => void
  placeholder: string
  onKeyDown?: (event: React.KeyboardEvent) => void
  size: string
  value: string
  dataAttributes: Record<string, string>
  autoFocus?: boolean
  type?: string
}

const InputButton: FC<InputButtonProps> = (props: InputButtonProps) => {
  const { buttonProps, ...inputProps } = props
  const button = !buttonProps.hasCustomButton ? (
    <div className="nr5 pr1">
      <Button {...buttonProps} variation={'secondary'}>
        {buttonProps.text}
      </Button>
    </div>
  ) : null

  return <Input {...inputProps} suffix={button} />
}

export default InputButton
